import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  state: {
    ambulances:[],
    selectedAmbulance:undefined
  },
  mutations: {

    setAmbulances(state, payload) {
        state.ambulances = payload
    },
    
    setSelectedAmbulance(state, payload) {
        state.selectedAmbulance = payload //TODO: Change to victims. Falar para  Breno
    },
  },
  actions: {
      
    async addNewAmbulance ({rootState}, payload){
        let headerConfig = {
            headers: {
                Authorization: `bearer ${rootState.User.userToken}`
            }
        };
        return await this.$http.post("api/administrators/ambulances", payload, headerConfig)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error;
            });
    },
    async removeAmbulance ({rootState}, id){
        let headerConfig = {
            headers: {
                Authorization:  `bearer ${rootState.User.userToken}`
            }
        };
        return await this.$http.delete(`api/administrators/ambulances/${id}`, headerConfig)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error
            });
        
    },
    async editAmbulance ({rootState}, payload){
        
        let headerConfig = {
            headers: {
                Authorization: `bearer ${rootState.User.userToken}`
            }
        };
        return await this.$http.put(`api/administrators/ambulances/${payload.id}`, payload, headerConfig)
            .then(response => {
                return response;
            })
            .catch(error => {
                return error;
            })
        
    },
    
    async downloadAmbulance ({ commit, rootState }){
        let headerConfig = {
            headers: {
                Authorization: `bearer ${rootState.User.userToken}`
            }
        };
        return await this.$http.get("api/administrators/ambulances", headerConfig)
            .then(response => {
                if (response.data.ambulances){
                    commit("setAmbulances", response.data.ambulances)
                }
                return response;
            })
            .catch(error => {
                return error;
            })
    },


  },
  getters: {
    selectedAmbulance(state) {
      return state.selectedAmbulance;
    },
    ambulances (state){
        return state.ambulances
    }
  }
};
